var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22406 4.43881C3.50467 3.40357 4.58114 2.78921 5.62841 3.06661L19.6539 6.78157C20.0762 6.89344 20.1509 7.45423 19.7723 7.67034L17.1919 9.14302L16.6838 11.0175C16.5435 11.5351 16.0052 11.8423 15.4816 11.7036L3.15599 8.43889C2.63235 8.30019 2.3216 7.76814 2.46191 7.25052L3.22406 4.43881ZM5.10307 5.94106C4.99784 6.32927 5.2309 6.72831 5.62363 6.83233L10.3642 8.08799C10.7569 8.19201 11.1606 7.96163 11.2659 7.57341C11.3711 7.1852 11.138 6.78616 10.7453 6.68214L6.0047 5.42648C5.61198 5.32246 5.2083 5.55284 5.10307 5.94106Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4562 10.102L19.4959 9.50868L20.7027 9.10512C21.4453 8.85678 22.1683 9.52682 21.9653 10.2754L20.3742 16.1453C20.1713 16.8938 19.2063 17.1168 18.6888 16.5347L16.0061 13.5171L15.9215 13.8292C15.6409 14.8644 14.5644 15.4788 13.5172 15.2014L10.5888 14.4257V16.1485C10.5888 17.6222 9.38023 18.8168 7.88944 18.8168H4.85195C4.52505 20.0723 3.37212 21 2 21V15.1782C3.37212 15.1782 4.52505 16.1059 4.85195 17.3614H7.88944C8.56707 17.3614 9.1164 16.8184 9.1164 16.1485V14.0357L4.03591 12.6901C2.98864 12.4127 2.36714 11.3486 2.64776 10.3133L2.77488 9.84473L15.1005 13.1094C16.4096 13.4562 17.7552 12.6882 18.106 11.3942L18.4562 10.102Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.482e07044d278dda1a60041696095786.svg";
export { ForwardRef as ReactComponent };